import { ExternalLink } from "lucide-react"
import { cn } from "@/lib/cn"
import { toneCss } from "../format"
import { safeHref } from "../safe-url"
import type { LinkRowBlock } from "../types"

// Row of deep-link buttons (navigation only). Stacks full-width at xs;
// inline at md+. Tap target ≥ 44×44 px even when wrapped.
export function LinkRowBlockView({ block }: { block: LinkRowBlock }) {
  const links = Array.isArray(block.links) ? block.links : []
  return (
    <div className="flex flex-wrap gap-2 valet-uidoc-linkrow">
      {links.map((l, idx) => {
        const safe = safeHref(l.href)
        if (safe === null) return null
        const css = toneCss(l.tone)
        return (
          <a
            key={`${l.label}-${idx}`}
            href={safe}
            target="_blank"
            rel="noopener noreferrer"
            referrerPolicy="no-referrer"
            className={cn(
              "valet-uidoc-link inline-flex min-h-[44px] items-center gap-1.5 rounded-control border px-3 py-2 text-sm font-medium transition",
              css.text,
              css.bg,
              css.border,
              "hover:brightness-110",
            )}
          >
            <span>{l.label}</span>
            <ExternalLink size={14} strokeWidth={2} aria-hidden="true" />
          </a>
        )
      })}
    </div>
  )
}
